import { useMemo } from 'react';
import styled from '@emotion/styled';
import useTheme from 'hooks/useTheme';
import { RectangleBlur } from 'styles/styled';
import { breakPoints } from 'constant/breakPoints';
import useMediaQuery from 'hooks/useMediaQuery';

function LegalPrivacy() {
  useTheme({
    light: false,
  });

  const isDesktopScreen = useMediaQuery(
    `(min-width: ${breakPoints.tabletS}px)`,
  );

  const leftBlurRectangleProp = useMemo(() => {
    if (isDesktopScreen)
      return {
        top: '28%',
        left: '-215px',
        width: '397px',
      };

    return {
      top: '21%',
      left: '-195px',
      width: '269px',
    };
  }, [isDesktopScreen]);

  const rightBlurRectangleProp = useMemo(() => {
    if (isDesktopScreen)
      return {
        top: '70%',
        width: '450px',
      };

    return {
      top: '53%',
      width: '300px',
    };
  }, [isDesktopScreen]);

  return (
    <Wrap>
      <RectangleBlur
        width={leftBlurRectangleProp.width}
        rotate={-135.07}
        left={leftBlurRectangleProp.left}
        top={leftBlurRectangleProp.top}
        className="rec-xs-bottom"
        zIndex={-1}
      />
      <RectangleBlur
        width={rightBlurRectangleProp.width}
        rotate={45.07}
        right="-226px"
        top={rightBlurRectangleProp.top}
        className="rec-xs-top"
        zIndex={-1}
      />
      <Content>
        <Title>Legal & Privacy</Title>
        <div>
          {LEGAL_PRIVACY_MOCK_DATA.map((item) => (
            <Item key={item.id}>
              <ItemName>{item.name}</ItemName>
              <Description>{item.description}</Description>
            </Item>
          ))}
        </div>
      </Content>
    </Wrap>
  );
}

export default LegalPrivacy;

const LEGAL_PRIVACY_MOCK_DATA = [
  {
    id: '1',
    name: 'Collection of Information',
    description: (
      <>
        <p>
          Spirit Labs is concerned to ensure that all personal data submitted
          through Spirit Labs website www.spiritlabs.co (“Spirit Labs Website”)
          are handled in strict adherence to the relevant provisions of the
          Personal Data (Privacy) Ordinance.
        </p>
        <p className="collection-information">
          Spirit Labs will record the visits to Spirit Labs Website by using
          cookies and page tagging without collecting any personal identifiable
          information of users.
        </p>
      </>
    ),
  },
  {
    id: '2',
    name: 'Cookies',
    description: (
      <p>
        A cookie is a small amount of data created in a computer when a person
        visits a website. It often includes an anonymous unique identifier. A
        cookie can be used to identify a device. It, however, is not used to
        collect any personal information. In other words, it does not have the
        function of identifying an individual user of the website. Cookies are
        used by Spirit Labs to collect statistics about the number of visits of
        users to Spirit Labs Website and the users’ preference of websites and
        online services offered on Spirit Labs. You may choose to accept or
        reject cookies. If you reject the cookies, you will not be able to use
        some of the functions of Spirit Labs , such as saving your preferences
        in using Spirit Labs Website and accessing some online services on
        Spirit Labs Website.
      </p>
    ),
  },
  {
    id: '3',
    name: 'Page Tagging',
    description: (
      <p>
        Javascript and pixel tags are used to collect statistics on customer
        usage patterns of Spirit Labs Website and Spirit Labs online services
        offered on Spirit Labs Website; and for tracking the performance of our
        online advertisements. A pixel tag is a transparent image placed on
        certain webpages to collect data on user activities. The collected data
        are aggregated and analysed for measuring the effectiveness, improving
        the usability of Spirit Labs Website and the services provided. No
        personal or identifiable information about a visitor would be collected.
        You may disable JavaScript on your device. Disabling JavaScript should
        not affect your access to Spirit Labs Website, but you will not be able
        to use some of Spirit Labs Website functions, such as changing text size
        and accessing Spirit Labs online services offered through Spirit Labs
        Website.
      </p>
    ),
  },
  {
    id: '4',
    name: 'Provision of Personal Data',
    description: (
      <p>
        For different purposes and at different times you may be invited to
        provide personal data to Spirit Labs through Spirit Labs Website on a
        voluntary basis. Personal information may include your name, company
        name, telephone number or e-mail address. Spirit Labs will specify the
        collection purpose and intended usage of your data when it invites you
        to provide such information. Unless permitted or required by law, Spirit
        Labs will not disclose your personal data to any third parties without
        your prior consent. Spirit Labs Website uses SSL protocol to encrypt
        data during network transmission to protect your personal data. All
        personal data you provide to Spirit Labs via Spirit Labs Website are
        secured, and access to them is restricted to authorised personnel only.
      </p>
    ),
  },
  {
    id: '5',
    name: 'What you can do for your Personal Data we maintain',
    description: (
      <>
        <p>
          What you can do for your Personal Data we maintain
        </p>
        <p>You have the rights to:</p>
        <p>(a) request access to your Personal Data;</p>
        <p>(b) request for correction or deletion of your Personal Data;  </p>
        <p>(c) withdraw consent for us to collect, use and disclose your Personal Data under this Policy.</p>
        <p>Please be noted that your request may be denied to the extent required or permitted by applicable laws or regulations.</p>
      </>
    ),
  },
  {
    id: '6',
    name: "How you can contact us",
    description: (
      <>
        <p>If you have any concerns for your Personal Data, please contact us via mail to the address below:</p>
        <p>Spirit Lab Ltd., Co.</p>
        <p>Address: Floor 16, WorkPlace PL Building, 16 Nguyen Truong To Street, Ward 13, District 4, Ho Chi Minh City, Vietnam</p>
        <p>Tel: <a href="tel:+842838212227">(+84) 28 38 212 227</a></p>
        <p>Email: <a href="mailto:hr@spiritlabs.co">hr@spiritlabs.co</a></p>
        <p>Attn: Legal Department</p>
      </>
    )
  }
];

const Title = styled.h1`
  font-weight: 600;
  font-size: 64px;
  line-height: 72px;
  text-align: center;
  padding-top: 108px;
  margin-bottom: 64px;

  @media screen and (max-width: ${breakPoints.tabletS}px) {
    font-weight: 600;
    font-size: 32px;
    line-height: 36px;
    padding-top: 25px;
    margin-bottom: 24px;
  }
`;

const Wrap = styled.div`
  position: relative;
`;

const Content = styled.div`
  max-width: 800px;
  padding: 90px 16px 114px;
  margin: 0 auto;
  width: 100%;

  @media screen and (max-width: ${breakPoints.tabletS}px) {
    padding: 90px 16px 60px;
  }
`;

const Item = styled.div`
  margin-top: 48px;

  @media screen and (max-width: ${breakPoints.tabletS}px) {
    margin-top: 24px;
  }
`;

const ItemName = styled.p`
  font-weight: 600;
  font-size: 28px;
  line-height: 32px;

  @media screen and (max-width: ${breakPoints.tabletS}px) {
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
  }
`;

const Description = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  margin-top: 16px;

  .collection-information {
    margin-top: 12px;
  }

  @media screen and (max-width: ${breakPoints.tabletS}px) {
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
  }
`;
